<template>
  <section class="about-hero" id="identification">
    <div class="about-hero__inner" style="margin-top: 120px;">
      <!-- LEFT -->
      <div class="about-hero__media">
        <img
          class="about-hero__photo-bg"
          src="@/assets/IMG/fondo pequeño.png"
          alt="Fondo decorativo"
        />
        <img
          class="about-hero__nurse-img"
          src="@/assets/IMG/nurse.png"
          alt="Enfermera"
        />
      </div>

      <!-- RIGHT -->
      <div class="about-hero__copy">
        <h1 class="about-hero__title">
          <span class="about-hero__proteccion">PROTECCIÓN MÉDICA</span>
          <span class="about-hero__acompanha">QUE TE ACOMPAÑA</span>
          <strong class="about-hero__siempre">SIEMPRE</strong>
        </h1>

        <p class="about-hero__text">
          Somos una empresa enfocada en el desarrollo de pulseras de identificación médica que permiten acceder de forma inmediata a información vital en situaciones de emergencia.<br />
          Integramos tecnología NFC y QR en un diseño discreto, resistente y funcional, pensado para brindar seguridad cuando cada segundo cuenta.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutHero"
};
</script>

<style scoped>
/* =========================
   SECCIÓN
========================= */
.about-hero {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background: #f3f4f6 !important;
  left: 50%;
  right: 0;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
  margin-left: 0;
  margin-right: 0;
  padding: 0 !important;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  z-index: 1;
}

.about-hero__bone-icon {
  color: var(--bones-color);
  font-size: clamp(66px, 6vw, 92px);
  line-height: 1;
  flex: 0 0 auto;
  display: inline-block;
  transform: rotate(45deg) scaleX(1);
  transform-origin: center;
}

/* =========================
   CONTENIDO
========================= */
.about-hero__inner {
  width: 100%;
  margin: 0;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  align-items: center;
  gap: clamp(24px, 4vw, 64px);
  padding-right: clamp(14px, 3.2vw, 48px);
  position: relative;
  z-index: 2;
}

/* IZQUIERDA */
.about-hero__media {
  position: relative;
  min-height: clamp(480px, 49vw, 700px);
  overflow: visible;
  background: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.about-hero__img {
  position: absolute;
  left: 0;
  bottom: 0%;
  width: auto;
  height: 98%;
  max-width: 100%;
  object-fit: contain;
  object-position: left bottom;
  z-index: 2;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.25));
  pointer-events: none;
  user-select: none;
}

.about-hero__photo-bg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 130%;
  height: 130%;
  max-width: 780px;
  object-fit: contain;
  z-index: 1;
  transform: translateY(70px);
}

.about-hero__nurse-img {
  position: relative;
  left: 0;
  bottom: 0;
  width: 130%;
  height: auto;
  max-width: 600px;
  object-fit: cover;
  object-position: left bottom;
  z-index: 2;
  filter: none;
  border: none;
  user-select: none;
  transform: translateY(40px) translateX(220px);
}

/* DERECHA */
.about-hero__copy {
  position: relative;
  color: #004b5c;
  text-align: left;
  padding-right: clamp(0px, 1vw, 10px);
  transform: translateY(-60px);
  font-family: Arial, Helvetica, sans-serif;
  margin-top: 0;
  margin-bottom: 0;
}

.about-hero__title {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 2.7rem;
  font-weight: 400;
  color: #004b5c;
  line-height: 1.05;
  margin: 0 0 8px 0;
  letter-spacing: 0.01em;
  text-transform: none;
  overflow: visible;
}

.about-hero__title span,
.about-hero__title strong {
  display: block;
  margin: 0;
  padding: 0;
}

.about-hero__proteccion {
  font-size: 2.7rem;
  font-weight: 500;
}

.about-hero__acompanha {
  font-size: 2.7rem;
  font-weight: 500;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  line-height: 1.05;
  letter-spacing: 0.085em;
  display: inline-block;
}

.about-hero__siempre {
  font-size: 6.5rem;
  display: block;
  font-weight: 700;
  color: #004b5c;
  margin-top: -18px;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 0.92;
}

.about-hero__title .strong {
  font-weight: 700;
  font-size: 3.3rem;
  color: #00505e;
  letter-spacing: 0.01em;
  display: block;
}

.about-hero__text {
  font-family: Arial, Helvetica, sans-serif;
  color: #004b5c;
  font-size: 1.35rem;
  font-weight: 400;
  line-height: 1.18;
  margin-top: 12px;
  max-width: 465px;
  text-align: left;
}

/* =========================
   TABLET / IPAD
========================= */
@media (max-width: 1024px) {
  .about-hero {
    min-height: auto;
    padding: 40px 0 48px 0 !important;
  }

  .about-hero__inner {
    grid-template-columns: 1.02fr 0.98fr;
    gap: 20px;
    width: min(960px, 94%);
    margin: 0 auto;
    padding-right: 0;
    align-items: center;
  }

  .about-hero__copy {
    transform: translateY(-64px);
    text-align: left;
    padding-right: 0;
    margin-top: 0;
    margin-bottom: 0;
  }

  .about-hero__title {
    font-size: 2rem;
    line-height: 1;
    margin-bottom: 6px;
  }

  .about-hero__proteccion {
    font-size: 1.9rem;
  }

  .about-hero__acompanha {
    font-size: 2rem;
    line-height: 1;
    letter-spacing: 0.02em;
    margin-bottom: 0 !important;
  }

  .about-hero__siempre {
    font-size: 4.8rem !important;
    line-height: 0.92;
    margin-top: -10px;
  }

  .about-hero__text {
    font-size: 1.02rem;
    line-height: 1.42;
    max-width: 100%;
    margin-top: 14px;
    text-align: left;
  }

  .about-hero__media {
    min-height: 420px;
  }

  .about-hero__photo-bg {
    width: 112%;
    height: auto;
    max-width: 560px;
    left: -80px;
    bottom: auto;
    top: 0;
    transform: translateY(0); /* Más a la izquierda */
    transform-origin: left top;
  }

  .about-hero__nurse-img {
    width: 108%;
    max-width: 400px;
    height: auto;
    transform: translateY(18px); /* Eliminar translateX para pegar a la izquierda */
    left: 0;
  }
}

/* =========================
   IPAD PEQUEÑO / TABLET VERTICAL
   Sigue a 2 columnas, parecido al original
========================= */
@media (max-width: 820px) {
  .about-hero {
    min-height: auto;
    padding: 28px 0 34px 0 !important;
  }

  .about-hero__inner {
    grid-template-columns: 1fr 1fr;
    gap: 18px;
    width: min(94%, 760px);
    margin: 0 auto;
    padding-right: 0;
    align-items: center;
  }

  .about-hero__media {
    order: 1;
    min-height: 340px;
    display: block;
  }

  .about-hero__copy {
    order: 2;
    transform: translateY(-56px);
    text-align: left;
    padding-right: 0;
    max-width: 100%;
  }

  .about-hero__title {
    font-size: 1.45rem;
    line-height: 1;
    margin-bottom: 4px;
  }

  .about-hero__proteccion {
    font-size: 1.35rem;
  }

  .about-hero__acompanha {
    font-size: 1.4rem;
    line-height: 1;
    letter-spacing: 0.015em;
    margin-bottom: 0 !important;
  }

  .about-hero__siempre {
    font-size: 3.4rem !important;
    line-height: 0.92;
    margin-top: -8px !important;
  }

  .about-hero__text {
    font-size: 0.94rem;
    line-height: 1.48;
    max-width: 100%;
    margin: 14px 0 0;
    text-align: left;
  }

  .about-hero__photo-bg {
    width: min(430px, 118%);
    max-width: 430px;
    height: auto;
    left: -68px;
    top: 0;
    bottom: auto;
    transform: translateY(0) scaleX(-1); /* Más a la izquierda */
    transform-origin: left top;
  }

  .about-hero__nurse-img {
    width: min(300px, 42vw);
    max-width: 300px;
    height: auto;
    left: 0;
    transform: translateY(10px); /* Eliminar translateX para pegar a la izquierda */
  }
}

/* =========================
   CELULAR
========================= */
@media (max-width: 600px) {
  .about-hero__photo-bg {
    display: none;
  }

  .about-hero {
    min-height: auto;
    padding: 24px 0 28px 0 !important;
  }

  .about-hero__inner {
    grid-template-columns: 1fr;
    width: min(94%, 420px);
    gap: 10px;
  }

  .about-hero__copy {
    text-align: center;
    transform: translateY(-64px);
    order: 1;
  }

  .about-hero__title {
    font-size: 1.65rem;
    line-height: 1;
    margin-bottom: 2px;
  }

  .about-hero__proteccion {
    font-size: 1.95rem;
  }

  .about-hero__acompanha {
    font-size: 2.1rem;
    line-height: 1;
    letter-spacing: 0.015em;
    margin-bottom: 0 !important;
  }

  .about-hero__siempre {
    font-size: 5rem !important;
    line-height: 0.9;
    margin-top: -6px !important;
  }

  .about-hero__text {
    font-size: 0.92rem;
    line-height: 1.52;
    max-width: 100%;
    margin: 14px auto 0;
    text-align: center;
  }

  .about-hero__media {
    order: 2;
    min-height: 255px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .about-hero__nurse-img {
    position: static;
    left: 0;
    bottom: 0;
    max-width: 420px;
    width: min(420px, 98vw);
    height: auto;
    margin: 0 auto;
    object-fit: contain;
    object-position: center bottom;
    display: block;
    z-index: 2;
    transform: none;
  }
}

@media (max-width: 480px) {
  .about-hero {
    padding: 18px 0 24px 0 !important;
  }

  .about-hero__inner {
    width: min(94%, 360px);
  }

  .about-hero__copy {
    text-align: center;
    transform: translateY(-52px);
  }

  .about-hero__title {
    font-size: 1rem;
  }

  .about-hero__proteccion {
    font-size: 2.1rem;
  }

  .about-hero__acompanha {
    font-size: 2.05rem;
    letter-spacing: 0.01em;
  }

  .about-hero__siempre {
    font-size: 4.2rem !important;
    margin-top: -6px !important;
    line-height: 0.9;
  }

  .about-hero__text {
    font-size: 0.88rem;
    line-height: 1.48;
    max-width: 100%;
  }

  .about-hero__media {
    min-height: 220px;
  }

  .about-hero__nurse-img {
    width: 75vw;
    max-width: 320px;
    transform: none;
  }
}

@media (max-width: 390px) {
  .about-hero {
    padding: 16px 0 20px 0 !important;
  }

  .about-hero__inner {
    width: min(95%, 330px);
  }

  .about-hero__title {
    font-size: 0.92rem;
  }

  .about-hero__proteccion {
    font-size: 1.5rem;
  }

  .about-hero__acompanha {
    font-size: 1.65rem;
  }

  .about-hero__siempre {
    font-size: 3.6rem !important;
    margin-top: -4px !important;
    line-height: 0.9;
  }

  .about-hero__text {
    font-size: 0.84rem;
    line-height: 1.45;
  }

  .about-hero__media {
    min-height: 200px;
  }

  .about-hero__nurse-img {
    width: 70vw;
    max-width: 260px;
  }
}
</style>